<template>
    <section class="content-section container px-3">
        <h2 class="content-section-title mb-0">{{ title }}</h2>
        <Adapter
            v-for="(adapters, i) in adatpersInfo"
            :adapters="adapters"
            :key="i"
        />
    </section>
</template>

<script>
import Adapter from "./_adapter.vue";

export default {
    components: { Adapter },
    props: ['title', 'adatpersInfo'],
    data() {
        return {

        }
    }
}
</script>

<style lang="scss" scoped>
    .content-section:not(:last-child) {
        padding-bottom: 0;
    }
</style>